import React, { useCallback } from 'react';
import noop from 'lodash/noop';

import { Box } from '@lyearn/ui';
import { DropOverContainer } from '@/components/DragDrop';
import Form, { FormProps } from '@/components/Form';
import useDraggableList from '@/modules/corporate/components/DraggableList/hooks/useDraggableList';
import { OnDropParams } from '@/modules/corporate/components/DraggableList/types';

import { fieldStyleOverrides } from '../../utils/formOverrides';
import FormEditorField from './components/FormEditorField';
import { DatabaseFormEditorProvider } from './context/DatabaseFormEditorContext';
import { DatabaseFormEditorActionEnum, DatabaseFormEditorProps } from './types';

export const SURVEY_QUESTIONS_FORM_OVERRIDES: FormProps['overrides'] = {
  FieldContainer: { className: fieldStyleOverrides },
  Label: { className: 'w-full flex items-center', variant: 'heading-xs', as: 'div' },
  spacing: {
    row: 'space-y-0',
  },
};
const DEFAULT_INITIAL_VALUES = {};

function DatabaseFormEditor(props: DatabaseFormEditorProps) {
  const {
    isFieldPublished,
    errors,
    getFieldAttributes,
    selectedFieldId,
    onFormEditorAction,
    fields,
  } = props;

  const onReorderFields = useCallback(
    (payload: OnDropParams) => {
      onFormEditorAction?.({ type: DatabaseFormEditorActionEnum.ReorderFields, payload });
    },
    [onFormEditorAction],
  );

  const { draggingItemRef, onDrop, getDropOverContainerProps } = useDraggableList({
    onDrop: onReorderFields,
  });

  return (
    <DatabaseFormEditorProvider
      draggingItemRef={draggingItemRef}
      errors={errors}
      getFieldAttributes={getFieldAttributes}
      isFieldPublished={isFieldPublished}
      selectedFieldId={selectedFieldId}
      onDrop={onDrop}
      onFormEditorAction={onFormEditorAction}>
      <Box className="-mx-40 mt-4">
        <DropOverContainer className="-mt-24 px-40" {...getDropOverContainerProps()}>
          <Box className="h-24" />
        </DropOverContainer>
        <Form
          FormField={FormEditorField}
          fields={fields}
          formName="DatabaseForm"
          initialValues={DEFAULT_INITIAL_VALUES}
          overrides={SURVEY_QUESTIONS_FORM_OVERRIDES}
          onSubmit={noop}
        />
      </Box>
    </DatabaseFormEditorProvider>
  );
}

export default DatabaseFormEditor;
